import Vue from 'vue'
import App from 'views/recruiterApplications/New.vue'

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    render: (h) => h(App),
  }).$mount()
  document.body.appendChild(app.$el)
})
